// Class: starling.filters.FragmentFilter

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $bind = require("./../../bind_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_events_EventDispatcher() {return require("./../../starling/events/EventDispatcher");}
function starling_core_Starling() {return require("./../../starling/core/Starling");}
function js__$Boot_HaxeError() {return require("./../../js/_Boot/HaxeError");}
function openfl_errors_IllegalOperationError() {return $import(require("openfl/errors/IllegalOperationError"));}
function starling_filters_FilterHelper() {return require("./../../starling/filters/FilterHelper");}
function starling_filters_FilterQuad() {return require("./../../starling/filters/FilterQuad");}
function starling_utils_Pool() {return require("./../../starling/utils/Pool");}
function starling_display_Stage() {return require("./../../starling/display/Stage");}
function starling_utils_RectangleUtil() {return require("./../../starling/utils/RectangleUtil");}
function starling_utils_MatrixUtil() {return require("./../../starling/utils/MatrixUtil");}
function js_Boot() {return require("./../../js/Boot");}
function starling_rendering_FilterEffect() {return require("./../../starling/rendering/FilterEffect");}
function starling_rendering_VertexData() {return require("./../../starling/rendering/VertexData");}
function starling_rendering_IndexData() {return require("./../../starling/rendering/IndexData");}
function starling_utils_Padding() {return require("./../../starling/utils/Padding");}
function openfl_errors_ArgumentError() {return $import(require("openfl/errors/ArgumentError"));}
function openfl_geom_Matrix3D() {return $import(require("openfl/geom/Matrix3D"));}

// Constructor

var FragmentFilter = function() {
	(starling_events_EventDispatcher().default).call(this);
	this._resolution = 1.0;
	this._textureFormat = "bgra";
	this._textureSmoothing = (starling_core_Starling().default).get_currentDefaultTextureSmoothing();
	(starling_core_Starling().default).get_current().get_stage3D().addEventListener("context3DCreate",$bind(this,this.onContextCreated),false,0,true);
}

// Meta

FragmentFilter.__name__ = "starling.filters.FragmentFilter";
FragmentFilter.__isInterface__ = false;
FragmentFilter.__super__ = (starling_events_EventDispatcher().default);
FragmentFilter.prototype = $extend((starling_events_EventDispatcher().default).prototype, {
	dispose: function() {
		(starling_core_Starling().default).get_current().get_stage3D().removeEventListener("context3DCreate",$bind(this,this.onContextCreated));
		if(this._helper != null) {
			this._helper.dispose();
		}
		if(this._effect != null) {
			this._effect.dispose();
		}
		if(this._quad != null) {
			this._quad.dispose();
		}
		this._effect = null;
		this._quad = null;
	},
	onContextCreated: function(event) {
		this.setRequiresRedraw();
	},
	render: function(painter) {
		if(this._target == null) {
			throw new (js__$Boot_HaxeError().default)(new (openfl_errors_IllegalOperationError().default)("Cannot render filter without target"));
		}
		if(this._target.get_is3D()) {
			this._cached = this._cacheRequested = false;
		}
		if(!this._cached || this._cacheRequested) {
			this.renderPasses(painter,this._cacheRequested);
			this._cacheRequested = false;
		} else if(this._quad.get_visible()) {
			this._quad.render(painter);
		}
	},
	renderPasses: function(painter,forCache) {
		if(this._helper == null) {
			this._helper = new (starling_filters_FilterHelper().default)(this._textureFormat);
		}
		if(this._quad == null) {
			this._quad = new (starling_filters_FilterQuad().default)(this._textureSmoothing);
		} else {
			this._helper.putTexture(this._quad.get_texture());
			this._quad.set_texture(null);
		}
		var bounds = (starling_utils_Pool().default).getRectangle();
		var drawLastPassToBackBuffer = false;
		var origResolution = this._resolution;
		var renderSpace = this._target.get_stage() != null ? this._target.get_stage() : this._target.get_parent();
		var isOnStage = ((renderSpace) instanceof (starling_display_Stage().default));
		var stage = (starling_core_Starling().default).get_current().get_stage();
		var stageBounds;
		if(!forCache && (this._alwaysDrawToBackBuffer || this._target.get_requiresRedraw())) {
			drawLastPassToBackBuffer = painter.get_state().get_alpha() == 1.0 && (!this._maintainResolutionAcrossPasses || this._resolution == 1.0);
			painter.excludeFromCache(this._target);
		}
		if(this._target == (starling_core_Starling().default).get_current().get_root()) {
			stage.getStageBounds(this._target,bounds);
		} else {
			this._target.getBounds(renderSpace,bounds);
			if(!forCache && isOnStage) {
				stageBounds = stage.getStageBounds(null,(starling_utils_Pool().default).getRectangle());
				(starling_utils_RectangleUtil().default).intersect(bounds,stageBounds,bounds);
				(starling_utils_Pool().default).putRectangle(stageBounds);
			}
		}
		this._quad.set_visible(!bounds.isEmpty());
		if(!this._quad.get_visible()) {
			(starling_utils_Pool().default).putRectangle(bounds);
			return;
		}
		if(this._padding != null) {
			(starling_utils_RectangleUtil().default).extend(bounds,this._padding.get_left(),this._padding.get_right(),this._padding.get_top(),this._padding.get_bottom());
		}
		(starling_utils_RectangleUtil().default).extendToWholePixels(bounds,(starling_core_Starling().default).get_current().get_contentScaleFactor());
		this._helper.set_textureScale((starling_core_Starling().default).get_current().get_contentScaleFactor() * this._resolution);
		this._helper.set_projectionMatrix3D(painter.get_state().get_projectionMatrix3D());
		this._helper.set_renderTarget(painter.get_state().get_renderTarget());
		this._helper.set_clipRect(painter.get_state().get_clipRect());
		this._helper.set_targetBounds(bounds);
		this._helper.set_target(this._target);
		this._helper.start(this.get_numPasses(),drawLastPassToBackBuffer);
		this._quad.setBounds(bounds);
		this._resolution = 1.0;
		var wasCacheEnabled = painter.get_cacheEnabled();
		var input = this._helper.getTexture();
		painter.set_cacheEnabled(false);
		painter.pushState();
		painter.get_state().set_alpha(1.0);
		painter.get_state().set_clipRect(null);
		painter.get_state().setRenderTarget(input,true,this._antiAliasing);
		painter.get_state().setProjectionMatrix(bounds.x,bounds.y,input.get_root().get_width(),input.get_root().get_height(),stage.get_stageWidth(),stage.get_stageHeight(),stage.get_cameraPosition());
		this._target.render(painter);
		painter.finishMeshBatch();
		painter.get_state().setModelviewMatricesToIdentity();
		var output = this.process(painter,this._helper,input);
		painter.popState();
		painter.set_cacheEnabled(wasCacheEnabled);
		if(output != null) {
			painter.pushState();
			if(this._target.get_is3D()) {
				painter.get_state().setModelviewMatricesToIdentity();
			} else {
				this._quad.moveVertices(renderSpace,this._target);
			}
			this._quad.set_texture(output);
			this._quad.render(painter);
			painter.finishMeshBatch();
			painter.popState();
		}
		this._helper.set_target(null);
		this._helper.putTexture(input);
		this._resolution = origResolution;
		(starling_utils_Pool().default).putRectangle(bounds);
	},
	process: function(painter,helper,input0,input1,input2,input3) {
		var effect = this.get_effect();
		var output = helper.getTexture(this._resolution);
		var projectionMatrix;
		var bounds = null;
		var renderTarget;
		if(output != null) {
			renderTarget = output;
			projectionMatrix = (starling_utils_MatrixUtil().default).createPerspectiveProjectionMatrix(0,0,output.get_root().get_width() / this._resolution,output.get_root().get_height() / this._resolution,0,0,null,FragmentFilter.sMatrix3D);
		} else {
			bounds = helper.get_targetBounds();
			renderTarget = ((js_Boot().default).__cast(helper , (starling_filters_FilterHelper().default))).get_renderTarget();
			projectionMatrix = ((js_Boot().default).__cast(helper , (starling_filters_FilterHelper().default))).get_projectionMatrix3D();
			effect.set_textureSmoothing(this._textureSmoothing);
			painter.get_state().set_clipRect(((js_Boot().default).__cast(helper , (starling_filters_FilterHelper().default))).get_clipRect());
			painter.get_state().get_projectionMatrix3D().copyFrom(projectionMatrix);
		}
		painter.get_state().set_renderTarget(renderTarget);
		painter.prepareToDraw();
		var _g = painter;
		_g.set_drawCount(_g.get_drawCount() + 1);
		input0.setupVertexPositions(this.get_vertexData(),0,"position",bounds);
		input0.setupTextureCoordinates(this.get_vertexData());
		effect.set_texture(input0);
		effect.set_mvpMatrix3D(projectionMatrix);
		effect.uploadVertexData(this.get_vertexData());
		effect.uploadIndexData(this.get_indexData());
		effect.render(0,this.get_indexData().get_numTriangles());
		return output;
	},
	createEffect: function() {
		return new (starling_rendering_FilterEffect().default)();
	},
	cache: function() {
		this._cached = this._cacheRequested = true;
		this.setRequiresRedraw();
	},
	clearCache: function() {
		this._cached = this._cacheRequested = false;
		this.setRequiresRedraw();
	},
	addEventListener: function(type,listener) {
		if(type == "enterFrame" && this._target != null) {
			this._target.addEventListener("enterFrame",$bind(this,this.onEnterFrame));
		}
		(starling_events_EventDispatcher().default).prototype.addEventListener.call(this,type,listener);
	},
	removeEventListener: function(type,listener) {
		if(type == "enterFrame" && this._target != null) {
			this._target.removeEventListener(type,$bind(this,this.onEnterFrame));
		}
		(starling_events_EventDispatcher().default).prototype.removeEventListener.call(this,type,listener);
	},
	onEnterFrame: function(event) {
		this.dispatchEvent(event);
	},
	get_effect: function() {
		if(this._effect == null) {
			this._effect = this.createEffect();
		}
		return this._effect;
	},
	get_vertexData: function() {
		if(this._vertexData == null) {
			this._vertexData = new (starling_rendering_VertexData().default)(this.get_effect().get_vertexFormat(),4);
		}
		return this._vertexData;
	},
	get_indexData: function() {
		if(this._indexData == null) {
			this._indexData = new (starling_rendering_IndexData().default)(6);
			this._indexData.addQuad(0,1,2,3);
		}
		return this._indexData;
	},
	setRequiresRedraw: function() {
		this.dispatchEventWith("change");
		if(this._target != null) {
			this._target.setRequiresRedraw();
		}
		if(this._cached) {
			this._cacheRequested = true;
		}
	},
	get_numPasses: function() {
		return 1;
	},
	onTargetAssigned: function(target) {
	},
	get_padding: function() {
		if(this._padding == null) {
			this._padding = new (starling_utils_Padding().default)();
			this._padding.addEventListener("change",$bind(this,this.setRequiresRedraw));
		}
		return this._padding;
	},
	set_padding: function(value) {
		this.get_padding().copyFrom(value);
		return value;
	},
	get_isCached: function() {
		return this._cached;
	},
	get_resolution: function() {
		return this._resolution;
	},
	set_resolution: function(value) {
		if(value != this._resolution) {
			if(value > 0) {
				this._resolution = value;
			} else {
				throw new (js__$Boot_HaxeError().default)(new (openfl_errors_ArgumentError().default)("resolution must be > 0"));
			}
			this.setRequiresRedraw();
		}
		return value;
	},
	get_maintainResolutionAcrossPasses: function() {
		return this._maintainResolutionAcrossPasses;
	},
	set_maintainResolutionAcrossPasses: function(value) {
		return this._maintainResolutionAcrossPasses = value;
	},
	get_antiAliasing: function() {
		return this._antiAliasing;
	},
	set_antiAliasing: function(value) {
		if(value != this._antiAliasing) {
			this._antiAliasing = value;
			this.setRequiresRedraw();
		}
		return value;
	},
	get_textureSmoothing: function() {
		return this._textureSmoothing;
	},
	set_textureSmoothing: function(value) {
		if(value != this._textureSmoothing) {
			this._textureSmoothing = value;
			if(this._quad != null) {
				this._quad.set_textureSmoothing(value);
			}
			this.setRequiresRedraw();
		}
		return value;
	},
	get_textureFormat: function() {
		return this._textureFormat;
	},
	set_textureFormat: function(value) {
		if(value != this._textureFormat) {
			this._textureFormat = value;
			if(this._helper != null) {
				this._helper.set_textureFormat(value);
			}
			this.setRequiresRedraw();
		}
		return value;
	},
	get_alwaysDrawToBackBuffer: function() {
		return this._alwaysDrawToBackBuffer;
	},
	set_alwaysDrawToBackBuffer: function(value) {
		return this._alwaysDrawToBackBuffer = value;
	},
	setTarget: function(target) {
		if(target != this._target) {
			var prevTarget = this._target;
			this._target = target;
			if(target == null) {
				if(this._helper != null) {
					this._helper.purge();
				}
				if(this._effect != null) {
					this._effect.purgeBuffers();
				}
				if(this._quad != null) {
					this._quad.disposeTexture();
				}
			}
			if(prevTarget != null) {
				prevTarget.set_filter(null);
				prevTarget.removeEventListener("enterFrame",$bind(this,this.onEnterFrame));
			}
			if(target != null) {
				if(this.hasEventListener("enterFrame")) {
					target.addEventListener("enterFrame",$bind(this,this.onEnterFrame));
				}
				this.onTargetAssigned(target);
			}
		}
	}
});
FragmentFilter.prototype.__class__ = FragmentFilter.prototype.constructor = $hxClasses["starling.filters.FragmentFilter"] = FragmentFilter;

// Init

Object.defineProperties(FragmentFilter.prototype,{ effect : { get : function () { return this.get_effect (); }}, vertexData : { get : function () { return this.get_vertexData (); }}, indexData : { get : function () { return this.get_indexData (); }}, numPasses : { get : function () { return this.get_numPasses (); }}, padding : { get : function () { return this.get_padding (); }, set : function (v) { return this.set_padding (v); }}, isCached : { get : function () { return this.get_isCached (); }}, resolution : { get : function () { return this.get_resolution (); }, set : function (v) { return this.set_resolution (v); }}, antiAliasing : { get : function () { return this.get_antiAliasing (); }, set : function (v) { return this.set_antiAliasing (v); }}, textureSmoothing : { get : function () { return this.get_textureSmoothing (); }, set : function (v) { return this.set_textureSmoothing (v); }}, textureFormat : { get : function () { return this.get_textureFormat (); }, set : function (v) { return this.set_textureFormat (v); }}, alwaysDrawToBackBuffer : { get : function () { return this.get_alwaysDrawToBackBuffer (); }, set : function (v) { return this.set_alwaysDrawToBackBuffer (v); }}});

// Statics


FragmentFilter.sMatrix3D = new (openfl_geom_Matrix3D().default)()

// Export

exports.default = FragmentFilter;